/**
 * @description 编辑器工具栏 事件总线
 * 用于通知父容器工具栏浮层展开/收起，以调整编辑器高度
 */
import mitt from 'mitt';

export type EditorToolbarEvents = {
  /** 工具栏浮层展开/收起事件，参数为浮层行数（0=收起，1=单行，2=双行） */
  toolbarPopoverChange: number;
};

const editorToolbarEmitter = mitt<EditorToolbarEvents>();
export default editorToolbarEmitter;
